import React from 'react';
import { BRAND_THEME } from '../../ui/brandTheme';

const FormSelect = ({
    label,
    register,
    name,
    error,
    options = [],
    placeholder = "Select option",
    icon: Icon,
    required = false,
    disabled = false,
    className = "",
    size = "md",
}) => {
    const isCompact = size === "sm";

    return (
        <div className={`${isCompact ? "space-y-1" : "space-y-1.5"} ${className}`}>
            {label ? (
                <label
                    htmlFor={name}
                    className={`block font-medium text-slate-700 ${
                        isCompact ? "text-xs" : "text-sm font-semibold ml-1"
                    }`}
                >
                    {label} {required && <span className="text-red-500">*</span>}
                </label>
            ) : null}
            <div className="relative group">
                {Icon && (
                    <div className={`absolute inset-y-0 left-0 ${isCompact ? "pl-2.5" : "pl-3"} flex items-center pointer-events-none text-slate-400 group-focus-within:text-indigo-500 transition-colors`}>
                        <Icon className={isCompact ? "w-4 h-4" : "w-5 h-5"} />
                    </div>
                )}
                <select
                    id={name}
                    {...register(name)}
                    disabled={disabled}
                    onInvalid={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    className={`
            block w-full border bg-white text-slate-900 appearance-none
            transition-colors duration-200 ease-in-out outline-none cursor-pointer
            disabled:bg-indigo-50/40 disabled:text-slate-500 disabled:cursor-not-allowed
            ${isCompact
                            ? "rounded-md text-sm py-1.5 shadow-none"
                            : "rounded-lg sm:text-sm py-2.5 shadow-sm"
                        }
            ${Icon ? (isCompact ? "pl-8" : "pl-10") : (isCompact ? "pl-2.5" : "pl-4")}
            ${isCompact ? "pr-8" : "pr-10"}
            ${error
                            ? `border-red-300 focus:border-red-400 ${isCompact ? "focus:ring-1 focus:ring-red-100" : "focus:ring-2 focus:ring-red-100"}`
                            : `border-indigo-200 hover:border-indigo-300 ${BRAND_THEME.fieldFocus}`
                        }
          `}
                >
                    <option value="" disabled hidden>{placeholder}</option>
                    {options.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>

                {/* Custom Chevron for better styling */}
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-indigo-400">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </div>

            </div>
            {error && (
                <p className="text-red-500 text-xs font-semibold ml-1 flex items-center gap-1 animate-fadeIn">
                    {error.message}
                </p>
            )}
        </div>
    );
};

export default FormSelect;
